module.exports = __webpack_public_path__ + "assets/my-funds.05c274f4.svg";